import React from 'react';
import { useParams } from 'react-router-dom';

import MaintenanceWindowDetailV2Container from '@totem/components/maintenanceWindowsV2/detail/MaintenanceWindowDetailV2Container';
import MaintenanceWindowDetailV2Layout from '@totem/components/maintenanceWindowsV2/detail/MaintenanceWindowDetailV2Layout';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const MaintenanceWindowDetailV2Page = () => {
  const { id } = useParams();

  return (
    <ContentLayout>
      <MaintenanceWindowDetailV2Container id={id}>
        <MaintenanceWindowDetailV2Layout />
      </MaintenanceWindowDetailV2Container>
    </ContentLayout>
  );
};

export default MaintenanceWindowDetailV2Page;
